import React from 'react';
import InvestorMenuLink from 'components/Models/InvestorMenuLink/InvestorMenuLink';
import InvestorLink from 'components/InvestorLink';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './InvestorMainMenu.scss';

class InvestorMainMenu extends React.PureComponent {
    state = {
        activeIndex: null,
    };

    toggleSubmenu = (index) => {
        this.setState((prevState) => ({
            activeIndex: prevState.activeIndex === index ? null : index,
        }));
    };

    render() {
        const { links, className, lang, onLinkClick } = this.props;
        const { activeIndex } = this.state;

        if (!links || links.length === 0) return null;

        return (
            <nav className={cn('investor-main-menu', className)} aria-label={lang.mainMenuAriaLabel}>
                <ul className="investor-main-menu__list">
                    {links.map((link, index) => {
                        const isOpened = activeIndex === index;
                        const hasSecondaryMenu = link.secondaryMenu &&
                            link.secondaryMenu.links &&
                            link.secondaryMenu.links.length > 0;

                        return (
                            <li key={index} className="investor-main-menu__item">
                                <div className="investor-main-menu__item-holder">
                                    <InvestorLink
                                        {...link}
                                        className={cn('investor-main-menu__link', {
                                            'investor-main-menu__link_active': link.isActive,
                                        })}
                                        onClick={onLinkClick}
                                    />
                                    {hasSecondaryMenu && (
                                        <button
                                            className={cn('investor-main-menu__submenu-toggle-button', {
                                                'investor-main-menu__submenu-toggle-button_opened': isOpened,
                                            })}
                                            onClick={() => this.toggleSubmenu(index)}
                                            aria-expanded={isOpened}
                                            aria-controls={`submenu-${index}`}
                                        >
                                            <span
                                                className={cn('investor-main-menu__submenu-toggle-button-icon', {
                                                    'investor-main-menu__submenu-toggle-button-icon_opened': isOpened,
                                                })}
                                            ></span>
                                        </button>
                                    )}
                                </div>
                                {hasSecondaryMenu && (
                                    <ul
                                        id={`submenu-${index}`}
                                        className={cn('investor-main-menu__submenu-list', {
                                            'investor-main-menu__submenu-list_opened': isOpened,
                                        })}
                                    >
                                        {link.secondaryMenu.links.map((sublink, subIndex) => (
                                            <li
                                                key={subIndex}
                                                className="investor-main-menu__submenu-item"
                                            >
                                                <InvestorLink
                                                    url={`${link.url}#${sublink.anchorId}`}
                                                    linkText={sublink.text}
                                                    openInNewWindow={link.openInNewWindow}
                                                    className="investor-main-menu__submenu-link"
                                                    onClick={onLinkClick}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </nav>
        );
    }
}

InvestorMainMenu.propTypes = {
    className: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape(InvestorMenuLink.propTypes)).isRequired,
    lang: PropTypes.shape({
        mainMenuAriaLabel: PropTypes.string.isRequired,
    }).isRequired,
    onLinkClick: PropTypes.func
};

export default InvestorMainMenu;



// WEBPACK FOOTER //
// ./src/components/InvestorMainMenu/InvestorMainMenu.jsx